export default "__VITE_ASSET__fa3d849d__"